// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PersonOrgAffiliation  {
    _originalTypeClassName = "Loom.BO.PersonOrgAffiliation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PersonOrgAffiliation.translate = translateService;
}
this.Id = null;
this.DateCreated = null;
this.ExpiryDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateCreated:any;
ExpiryDate:any;
AffiliatedPerson:any;
AffiliatedOrg:any;
static setAffiliatedPerson = ($this, value) => {
var oldValue = $this.AffiliatedPerson;
$this.AffiliatedPerson = value;
if (value != null) {
if (oldValue != null) {
Domain.Person.removeOrganisationAffiliations(oldValue, $this);
}
Domain.Person.addOrganisationAffiliations(value, $this);
}
}
static setAffiliatedOrg = ($this, value) => {
var oldValue = $this.AffiliatedOrg;
$this.AffiliatedOrg = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}